export default __webpack_public_path__ + "static/media/user.19767048.svg";